import { _sub, encrypt } from '~/utils'

export default ($axios, store) => ({
  // 通过code获取字典数组（单个）
  getDictItems(code) {
    return $axios.get('/app/sys/dict/getDictItems/' + code)
  },
  // 房源动态字典（按国家/租户取值，如 house_sub_type_Office）
  getHouseDictItems(dictCode) {
    return $axios.get('/app/house/houseDictItem/getDictItems/' + dictCode)
  },
  // 通过code获取字典数组（多个）
  getManyDictItems(params) {
    return $axios.get('/app/sys/dict/getManyDictItems' + _sub(params))
  },
  // 区域接口
  getProvinceList(params) {
    return $axios.get('/app/house/province/provinceList' + _sub(params))
  },
  // 热门区域列表
  getHotAreaList(params) {
    return $axios.get('/app/house/province/hotRegionList' + _sub(params))
  },
  // 房源列表
  houseList(params) {
    return encrypt(JSON.stringify(params), store).then((encryptText) =>
      $axios.post('/app/house/pageList', {
        encryptText,
      })
    )
  },
  // 获取房源详情
  getHouseDetailById(params) {
    return $axios.get('/app/house/queryById' + _sub(params))
  },
  // 获取房源内部详情（带价格）
  queryInternalById(params) {
    return $axios.get('/app/house/queryInternalById' + _sub(params))
  },
  // 获取最近距离设施
  getNearbySearchOfPlaces(params) {
    return $axios.get('/app/house/nearbySearchOfPlaces' + _sub(params), {
      timeout: 20000, // 仅为此请求设置超时时间
    })
  },
  // 获取房源静态地图
  getHouseStaticMap(params) {
    return $axios.get('/app/house/staticMap' + _sub(params), {
      timeout: 20000,
    })
  },
  // 查询系统配置（目前用来查询谷歌地图是否调用）
  getByKey(params) {
    return $axios.get('/app/system/sysProperties/getByKey' + _sub(params))
  },
  // 获取视频第一帧（苹果手机视频封面图使用）
  getFirstFrame(params) {
    return $axios.get('/app/house/getFirstFrame' + _sub(params))
  },

  // 获取国家联系人列表（联系我们悬浮球使用）
  getCountryInfoList(params) {
    return $axios.get('/app/house/houseContact/list' + _sub(params))
  },
  // 获取方案pk详情
  queryHousePkPlanDetail(params) {
    return $axios.get('/app/house/housePkPlan/queryHousePkPlanDetail' + _sub(params))
  },
  // 获取方案pk字段
  queryFieldByLinkId(params) {
    return $axios.get('/app/house/housePkPlan/queryFieldByLinkId' + _sub(params))
  },
  // 获取人民币兑本币汇率
  getCnyRate(params) {
    return $axios.get('/app/house/housePkPlan/cnyRate' + _sub(params))
  },
  // 获取单位配置（房源详情页费用单位会显使用）
  getUnitConfig(params) {
    return $axios.post('/app/house/unit/getFieldUnits', params)
  },
  // 获取房源国家列表
  getCountryList(params) {
    return $axios.get('/app/house/houseYzWebCountry/list' + _sub(params))
  },
  // 获取国家地址列表
  getAddressList(params) {
    return $axios.get('/app/house/houseYzWebAddress/list' + _sub(params))
  },
})
